export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-2.png?5189a2dd4842bb72e8b01ea4bd86b2ed";